import React from "react";
import { motion } from "framer-motion";
import { MARQUEES } from "../../data/content";

const Row = ({ items, dur, dir, opacity, weight }) => {
    // Duplicate the list so the -50% loop is seamless.
    const loop = [...items, ...items];
    return (
        <div
            className="marquee-pause group relative overflow-hidden border-b-2 border-[var(--ink)] py-2 md:py-3"
            style={{ opacity }}
        >
            <div
                className={`marquee-track ${dir === "right" ? "marquee-right" : "marquee-left"}`}
                style={{ ["--dur"]: `${dur}s` }}
            >
                {loop.map((it, i) => (
                    <span
                        key={i}
                        className="font-serif italic tracking-[-0.01em] text-3xl md:text-5xl leading-none inline-flex items-center"
                        style={{ fontWeight: weight }}
                    >
                        {it}
                        <span className="text-[var(--brand)] not-italic mx-6 md:mx-8 text-xl md:text-2xl">
                            ◆
                        </span>
                    </span>
                ))}
            </div>
        </div>
    );
};

export const TripleMarquee = () => {
    return (
        <section
            id="marquee"
            data-testid="marquee-section"
            className="relative border-t-2 border-[var(--ink)] bg-[var(--surface)]"
        >
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8 }}
                className="border-t-2 border-[var(--ink)]"
            >
                {MARQUEES.map((m, i) => (
                    <Row key={i} {...m} />
                ))}
            </motion.div>
        </section>
    );
};
